import ElementId from "types/enums/ElementId";

export default function scrollElementIntoView(id: ElementId): void {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
}
